import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import CustomTable from "../../../components/customTable/CustomTable";
import { LumpsumApi } from "../../../app/slices/reports/LumpsumSlice";
import { partnerListApi } from "../../../app/slices/reports/partnerListSlice";
import SearchFilterComponent from "./SearchFilterComponent";
import { createMRTColumnHelper } from "material-react-table";
import { ContentCopy } from "@mui/icons-material";
import { toast } from "react-toastify";
import ToastComponent from "../../../components/customTable/ToastComponent";

export default function Lumpsum() {
  const dispatch = useDispatch();
  const bussinessSliceResponse1 = useSelector(
    (state) => state.Lumpsum.Lumpsum.data?.transactions,
  );
  // console.log("LumpsumSlice SliceResponse: ", bussinessSliceResponse1);
  const totalAmount = useSelector(
    (state) => state.Lumpsum.Lumpsum.data?.totalAmount,
  );
  // console.log("LumpsumSlice total amount", totalAmount);

  const sliceResponse = useSelector(
    (state) => state.partnerList.partnerList.data,
  );

  const stateLoading = useSelector((state) => state.Lumpsum.loading);

  function flattenObject(obj, parentKey = "", result = {}) {
    for (let key in obj) {
      const value = obj[key];
      // const newKey = parentKey ? `${parentKey}__${key}` : key;
      const newKey = parentKey ? `${parentKey}_${key}` : key;

      if (
        value &&
        typeof value === "object" &&
        !Array.isArray(value) &&
        value !== null
      ) {
        flattenObject(value, newKey, result);
      } else {
        result[newKey] = value;
      }
    }
    return result;
  }
  // Flatten all transactions
  const bussinessSliceResponse = bussinessSliceResponse1?.map((transaction) =>
    flattenObject(transaction),
  );
  // console.log("bussinessSliceResponse: new ", bussinessSliceResponse);

  const handleSearch = (params) => {
    // console.log("params: ", params);
    dispatch(LumpsumApi(params));
  };

  useEffect(() => {
    dispatch(partnerListApi());
    dispatch(LumpsumApi({})); // Trigger the API call without parameters
  }, [dispatch]);

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("_id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?._id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row?.original?._id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("refinery", {
      header: "Refinery",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.refinery}</div>,
    }),

    columnHelper.accessor("client_id__id", {
      header: "Client ID",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.client_id__id}</div>,
    }),
    columnHelper.accessor("client_id_name", {
      header: "Client Name",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.client_id_name}</div>,
    }),

    columnHelper.accessor("partner_id", {
      header: "Partner ID",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.partner_id}</div>,
    }),

    columnHelper.accessor("proposal_id", {
      header: "Proposal ID",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.proposal_id}</div>,
    }),

    columnHelper.accessor("proposal_no", {
      header: "Proposal No",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.proposal_no}</div>,
    }),

    columnHelper.accessor("amount", {
      header: "Amount",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.amount}</div>,
    }),

    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.quantity}</div>,
    }),

    columnHelper.accessor("gst", {
      header: "GST",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.gst}</div>,
    }),

    columnHelper.accessor("total_amount", {
      header: "Total Amount",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.total_amount}</div>,
    }),

    columnHelper.accessor("Price", {
      header: "Price",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.Price}</div>,
    }),

    columnHelper.accessor("invoice_url", {
      header: "Invoice URL",
      size: 30,
      Cell: ({ cell }) => (
        <a
          href={cell.row?.original?.invoice_url}
          target="_blank"
          rel="noreferrer"
        >
          View Invoice
        </a>
      ),
    }),

    columnHelper.accessor("status", {
      header: "Status",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.status}</div>,
    }),

    columnHelper.accessor("payment_method", {
      header: "Payment Method",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.payment_method}</div>,
    }),

    columnHelper.accessor("transaction_id", {
      header: "Transaction ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () =>
          navigator.clipboard.writeText(cell.row?.original?.transaction_id);
        return (
          <>
            <Tooltip title={cell.row?.original?.transaction_id}>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
            </Tooltip>
            {cell.row?.original?.transaction_id}
          </>
        );
      },
    }),

    columnHelper.accessor("invoice_No", {
      header: "Invoice No",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.invoice_No}</div>,
    }),

    columnHelper.accessor("merchant_transaction_id", {
      header: "Merchant Transaction ID",
      size: 30,
      Cell: ({ cell }) => (
        <div>{cell.row?.original?.merchant_transaction_id}</div>
      ),
    }),

    columnHelper.accessor("metal_type", {
      header: "Metal Type",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.metal_type}</div>,
    }),

    columnHelper.accessor("payment_id", {
      header: "Payment ID",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.payment_id}</div>,
    }),

    columnHelper.accessor("commission", {
      header: "Commission",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.commission}</div>,
    }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: ({ cell }) => (
        <div>
          {new Date(cell.row?.original?.createdAt).toLocaleDateString()}
        </div>
      ),
    }),

    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: ({ cell }) => (
        <div>
          {new Date(cell.row?.original?.updatedAt).toLocaleDateString()}
        </div>
      ),
    }),
  ];

  return (
    <>
      {/*  */}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: { xs: 1.5, md: 3 },
          // border: "1px solid grey",
          mb: { xs: 1, md: 3 },
          background: "#dcdaff",
          color: "#4d16a4",
          borderRadius: "6px",
        }}
      >
        <Box sx={{ marginLeft: { xs: 0 } }}>
          <Typography variant={{ xs: "h2" }} component="div">
            Total Amount
          </Typography>
          <Typography variant="body1" component="div" sx={{ paddingLeft: 1 }}>
            {/* Batuk Partner */}
          </Typography>
        </Box>
        <Box sx={{ marginRight: { xs: 0 } }}>
          <Typography variant={{ xs: "body2" }} component="div">
            ₹ {totalAmount}
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={{ xs: 1, md: 3 }}>
        <Grid item xs={12}>
          <SearchFilterComponent
            sliceResponse={sliceResponse}
            onSearch={handleSearch}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTable
            columns={columns}
            data={bussinessSliceResponse}
            loading={stateLoading}
            permissionKey="Lumpsum"
          />
        </Grid>
      </Grid>
    </>
  );
}
